export default __webpack_public_path__ + "static/media/inside-story.8f3680f6.png";